export const reportsCenterErrorCodes = {
  DEFAULT: 'error_messages.default',
  MISSING_REPORT_RECORD: 'download_report_notifications.missing_report',
  MISSING_REPORT: 'download_report_notifications.missing_report',
  MISSING_VIEW_PERMISSIONS: 'error_messages.missing_view_permission',
  MISSING_EDIT_PERMISSIONS: 'error_messages.missing_edit_permission',
  MISSING_REPORT_CONFIGURATION: 'error_messages.missing_report_configuration',
};
